import { render, staticRenderFns } from "./LoginRecordView.vue?vue&type=template&id=2ed19b50&scoped=true"
import script from "./LoginRecordView.vue?vue&type=script&lang=js"
export * from "./LoginRecordView.vue?vue&type=script&lang=js"
import style0 from "./LoginRecordView.vue?vue&type=style&index=0&id=2ed19b50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed19b50",
  null
  
)

export default component.exports